import React from 'react'
import { Link } from "react-router-dom";
import coreImg2 from "../assets/img/home3/block2.png";
import coreImg1 from "../assets/img/ProductsDetails/AboutOilSeeds.jpg";
import PageBanner from "../Components/PageBanner";
import bannerBg from '../assets/img/Banners/Productpagebanner.jpg';
const Seeds = () => {
  return (
    <>
      
      <PageBanner title='Seeds ' bannerBg={bannerBg} currentPage=' Seeds  ' />
      <section className="content-block-wrapper section-padding bg-circle fix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 pe-xl-4 col-12">
              <div className="content-block-img justify-content-center">
                <img src={coreImg1} alt="" />
              </div>
            </div>
            <div className="col-xl-6 ps-xl-5 col-lg-6 col-12 mt-5 mt-lg-0">
              <div className="section-title-3">
                {/* <h6>Core Features</h6> */}
                <h2>About Oil Seeds
                </h2>
                <h6>Oilseeds, Grains, and Pulses</h6>
                <p>
                Although there are numerous varieties of oilseeds cultivated globally, the market is primarily driven by four key crops—soybean, palm, sunflower, and rapeseed—collectively known as the G-4. These four crops account for approximately 82% of global vegetable oil production and 85% of meal production. Our key export commodities include Sesame Seeds and Groundnut Kernels. 
                </p>
                <br></br>
                <p>
                Cereal crops, primarily belonging to the grass family, are cultivated for their edible seeds, which are technically classified as caryopses (a type of fruit). These grains are produced in larger quantities worldwide than any other crop, serving as the most significant source of dietary energy for human populations. In some developing regions, cereals form the backbone of daily nutrition, while in developed countries, consumption remains significant but more balanced. The term "cereal" originates from Ceres, the Roman goddess of agriculture and harvest. Historically, the word "corn" was used in the United Kingdom to refer to grains in general, though in countries like the United States, Canada, Australia, and New Zealand, it has become synonymous with maize. 
                </p>
                <br></br>
                
               
              </div>
              {/* <div className="checked-features-list style-2">
                <ul>
                  <li>Brand Identity</li>
                  <li>Website Design &amp; Development</li>
                  <li>SEO &amp; Analytics</li>
                </ul>
              </div> */}
              <Link to="/about" className="theme-btn style-3 mt-30">
                click here
              </Link>
            </div>
          </div>
         
        </div>
      </section>    
    </>
  )
}

export default Seeds
